// extracted by mini-css-extract-plugin
export default {"card":"PaymentInfoCard_card__7EfUI"};